// extracted by mini-css-extract-plugin
module.exports = {"editor":"CompanyNoteEditor_editor__2A_PC","postBtn":"CompanyNoteEditor_postBtn__2PCjI"};